import React, {useState, useEffect} from 'react';
import axios from 'axios';
import {genId} from '../components/ActionStatus';
import actionCable from 'actioncable';


export default function useApiConnector (actionLog) {

  const [jwt, setJWT] = useState("");
  const [options, setOptions] = useState({});
  const [datacentres, setDatacentres] = useState([]);
  const [groups, setGroups] = useState([]);
  const [users, setUsers] = useState([]);

  const instance = axios.create({
    baseURL: '/api/',
    timeout: 10000
  });

  const loginInstance = axios.create({
    baseURL: '/ui_auth/',
    timeout: 12000
  });

  const setJWTHeader = function(jwt) {
    setOptions({headers: {authorization: 'Bearer ' + jwt}});
    setJWT(jwt);
  }

  const applyChange = (oldObj, newObj) => {
    for (let key of Object.keys(newObj)) {
      if (oldObj.hasOwnProperty(key)) oldObj[key] = newObj[key][1];
    }
    return oldObj;
  }
  const checkForChange = (objList, data) => {
    let changed = false;
    let result = objList.map(obj => {
      if (obj.id == data.id) {
        changed = true;
        return applyChange(obj, data.updates)
      }
      return obj;
    })
    return {
      result: result,
      changed: changed
    }
  }

  const setAppData = (data) => {
    // Put empty datacentres last
    let dcs = data.sort((a, b) => {
      if (b.cabs.length === 0) return -1;
      if (a.cabs.length === 0) return 1;
      return a.cabs[0].cabId.localeCompare(b.cabs[0].cabId);
    })
    console.log("setting datacentres", dcs);
    setDatacentres(dcs);
  }

  const updateAppData = (data) => {
    setDatacentres((oldDcs) => {

      let found = false;
      let newDcs;
      if (data.type == 'Datacentre') {
        newDcs = checkForChange(oldDcs, data).result;
      } else {
        newDcs = oldDcs.map(d => {
          if (data.type == 'Cab') {
            d.cabs = checkForChange(d.cabs, data).result;
          } else {
            d.cabs = d.cabs.map(c => {
              if (data.type == 'Pdu') {
                c.pdus = checkForChange(c.pdus, data).result
              } else {
                c.pdus = c.pdus.map(p => {
                  if (data.type == 'Outlet') {
                    p.outlets = checkForChange(p.outlets, data).result
                  }
                  return p;
                })
              }
              return c;
            })
          }
          return d;
        })
      }
      return newDcs;

    })
  }

  const CableApp = {}

  // Begin Actioncable
  const [channel, setChannel] = useState(null)

  useEffect(() => {
    if (!jwt) return;
    CableApp.cable = actionCable.createConsumer(`/api/cable?token=${jwt}`)
    setChannel(CableApp.cable.subscriptions.create(
      {
        channel: 'AppDataChannel',
      },
      {
        received: (data) => {
          switch (data.action) {
            case 'update':
              updateAppData(data)
              break;
            case 'reimport':
              setAppData(JSON.parse(data.appdata))
              break;
          }
        },
      }
    ))
    return () => {
      try {
        channel.unsubscribe()
      } catch (e) {
        console.log("Failed to destroy hanging subscription")
      }
    }
  }, [jwt])

  // End Actioncable



  return {
    data: {
      datacentres: datacentres,
      groups: groups,
      users: users,
    },
    setJWT: setJWTHeader,
    logout: () => {
      setJWTHeader(null);
    },
    localLogin: async(username, password) => {
      console.log(`logging in with username ${username} and password ${password}`);
      try {
        let loginReq = await instance.post('/login', {username: username, password: password}, options);
        console.log("login response", loginReq.data);
        if(loginReq.data.jwt !== null) {
          console.log("setting JWT to ", loginReq.data.jwt);
          setJWTHeader(loginReq.data.jwt);
        }
        return loginReq.data;
      } catch (e) {
        if(e.response) {
          console.log("got error response", e.response);
          return e.response.data;
        } else if (e.request) {
          console.log("got error request", e.request);
          return {loggedIn: false, error: e.message}
        } else {
          console.log("got error", e.message);
          return {loggedIn: false, error: e.message}
        }
      }
    },
    getSSOToken: async() => {
      try {
        let res = await loginInstance.post('/sso');
        if(res.data.jwt) {
          setJWTHeader(res.data.jwt);
        }
        return res.data;
      } catch (err) {
        if(!err.response) return {loggedIn: false, error: 'No response from server'};
        return err.response.data
      }
    },
    getJWT: async(token, key) => {
      let res = await instance.post('/getJWT', {token: token, key: key});
      if(res.data.jwt) {
        setJWTHeader(res.data.jwt);
      }
      return res.data;
    },
    getDataCentres: async() => {
      let res = await instance.get('/appData', options)
      console.log(res);
      setAppData(res.data);
    },
    getGroups: async() => {
      let res = await instance.get('/groups', options)
      setGroups(res.data);
    },
    getUsers: async() => {
      let res = await instance.get('/users', options)
      setUsers(res.data);
    },
    createDatacentre: async(dcName) => {
      let dcRequest = instance.post('/datacentres', {name: dcName}, options)
      actionLog.pushAction({
        title: `Create Datacentre`,
        actionRequest: dcRequest,
        detail: "Waiting for response from server..."
      });
      return await dcRequest
    },
    createCab: async(dcId, cabId, cabName, pdu1Type, pdu2Type) => {
      let cabRequest = instance.post('/cabs', {datacentre_id: dcId, cabId: cabId, name: cabName, pdu1Type: pdu1Type, pdu2Type: pdu2Type}, options)
      actionLog.pushAction({
        title: `Create Cabinet`,
        actionRequest: cabRequest,
        detail: "Waiting for response from server..."
      });
      return await cabRequest
    },
    setPowerstate: async(outletId, outletIndex, pduName, newValue) => {
      let powerRequest = instance.post(`/outlets/${outletId}/setPowerstate`, {powerstate: newValue}, options);
      actionLog.pushAction({
        title: `${pduName}: ${newValue == 1 ? 'Enable' : 'Disable'} outlet ${outletIndex}`,
        actionRequest: powerRequest,
        detail: "Waiting for response from server..."
      });
      try {
        let response = await powerRequest;
        return response.status == 200;
      } catch (e) {
        return false;
      }
    },
    updateOutlet: async(outletId, outletIndex, pduName, params) => {
      let updateRequest = instance.put(`/outlets/${outletId}`, params, options);
      actionLog.pushAction({
        title: `${pduName}: Update outlet ${outletIndex}`,
        actionRequest: updateRequest,
        detail: "Waiting for response from server..."
      });
      return await updateRequest;
    },
    updateCab: async(id, cabId, params) => {
      let updateRequest = instance.put(`/cabs/${id}`, params, options);
      actionLog.pushAction({
        title: `Cab ${cabId}: Update`,
        actionRequest: updateRequest,
        detail: "Waiting for response from server..."
      });
      return await updateRequest;
    },
    deleteCab: async(id, cabId) => {
      let deleteRequest = instance.delete(`/cabs/${id}`, options);
      actionLog.pushAction({
        title: `Cab ${cabId}: Delete`,
        actionRequest: deleteRequest,
        detail: "Waiting for response from server..."
      });
      return await deleteRequest;
    },
    updateDatacentre: async(id, name, params) => {
      let updateRequest = instance.put(`/datacentres/${id}`, params, options);
      actionLog.pushAction({
        title: `Datacentre '${name}': Update`,
        actionRequest: updateRequest,
        detail: "Waiting for response from server..."
      });
      return await updateRequest;
    },
    deleteDatacentre: async(id, name) => {
      let deleteRequest = instance.delete(`/datacentres/${id}`, options);
      actionLog.pushAction({
        title: `Datacentre '${name}': Delete`,
        actionRequest: deleteRequest,
        detail: "Waiting for response from server..."
      });
      return await deleteRequest;
    },
    approveUser: async(id, display_name) => {
      let updateRequest = instance.put(`/users/${id}`, {approved: true}, options);
      actionLog.pushAction({
        title: `User '${display_name}': Approve`,
        actionRequest: updateRequest,
        detail: "Waiting for response from server..."
      });
    },
    createUser: async(_, username, groupId, password, passwordConfirmation) => {
      let createRequest = instance.post(`/users`, {username: username, group_id: groupId, password: password, password_confirmation: passwordConfirmation}, options);
      actionLog.pushAction({
        title: `User '${username}': create`,
        actionRequest: createRequest,
        detail: "Waiting for response from server..."
      });
      return await createRequest;
    },
    updateUser: async(id, username, groupId, password, passwordConfirmation) => {
      let updateRequest = instance.put(`/users/${id}`, {username: username, group_id: groupId, password: password, password_confirmation: passwordConfirmation}, options);
      actionLog.pushAction({
        title: `User '${username}': Update`,
        actionRequest: updateRequest,
        detail: "Waiting for response from server..."
      });
      return await updateRequest;
    },
    deleteUser: async(id, display_name) => {
      let deleteRequest = instance.delete(`/users/${id}`, options);
      actionLog.pushAction({
        title: `User '${display_name}': Delete`,
        actionRequest: deleteRequest,
        detail: "Waiting for response from server..."
      });
      return await deleteRequest;
    },
    createGroup: async(groupName, domain) => {
      let createRequest = instance.post(`/groups`, {name: groupName, domain: domain}, options);
      actionLog.pushAction({
        title: `Group '${groupName}': create`,
        actionRequest: createRequest,
        detail: "Waiting for response from server..."
      });
      return await createRequest;
    },
    deleteGroup: async(id, name) => {
      let deleteRequest = instance.delete(`/groups/${id}`, options);
      actionLog.pushAction({
        title: `Group '${name}': Delete`,
        actionRequest: deleteRequest,
        detail: "Waiting for response from server..."
      });
      return await deleteRequest;
    },
    refreshCab: async(id) => {
      let refreshRequest = instance.post(`/cabs/${id}/refresh`, {}, options);
      actionLog.pushAction({
        title: `Refresh Cab`,
        actionRequest: refreshRequest,
        detail: "Waiting for response from server..."
      });
      return await refreshRequest;
    }
  }
}